import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import OnboardingPlannerViewSectionHeader
  from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/Components/OnboardingPlannerViewSectionHeader';
import { useOnboardingPlannerViewSectionContext } from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/Sections/ViewSectionContext';
import {
  FDPrimaryActionButton,
  FDStack,
} from '@facet-wealth/design';
import fr from 'facet-rest';
import ReviewAccountStatementButton
  from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/Sections/BalanceSheet/UploadedAccountStatementsComponents/ReviewAccountStatementsButton';
import MemberResponse
  from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/Components/MoneyMindsetSubSection/MemberResponse';
import {
  OwnAndOweChecklist,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingAssetsAndLiabilitiesAdd/OnboardingAssetsAndLiabilitiesAddContent/OwnAndOweChecklist';
import {
  NoItemsAdded,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingAssetsAndLiabilitiesAdd/OnboardingAssetsAndLiabilitiesAddContent/NoItemsAdded';
import {
  InstitutionGroups,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingAssetsAndLiabilitiesAdd/OnboardingAssetsAndLiabilitiesAddContent/InstitutionGroups';
import { balanceSheetPageURL } from 'Hooks/useBalanceSheetPageURL';
import { openURLInNewTab } from 'Helpers/Navigation';

function ViewSectionLayout() {
  const {
    resource,
  } = useMetaLayoutContext();

  const {
    onAddTask,
    onAddNote,
  } = useOnboardingPlannerViewSectionContext();

  const [sectionDataResource] = resource.attr('sectionData');

  return (
    <FDStack direction={'column'} paddingX={3}>
      <OnboardingPlannerViewSectionHeader
        title={resource.attr('title')}
        onAddTask={onAddTask}
        onAddNote={onAddNote}
      />
      <FDStack direction={'column'} paddingX={2} paddingY={4} spacing={4}>
        <FDStack direction={'row'} spacing={1}>
          {sectionDataResource.withRelationship(fr.relationships.householdBalanceSheetPage.name,
            () => (
              <FDPrimaryActionButton
                label={'View in balance sheet'}
                onClick={() => openURLInNewTab(balanceSheetPageURL(sectionDataResource, sectionDataResource.attr('householdId'), true))}
              />
            ),
            () => null)}
          <ReviewAccountStatementButton relationship={sectionDataResource.relationship(fr.relationships.uploadedAccountStatements.name)} />
        </FDStack>
        {sectionDataResource.attr('memberResponses').resources().list().map((memberResponseResource) => {
          return <MemberResponse resource={memberResponseResource} />;
        })}
        <OwnAndOweChecklist resource={sectionDataResource} />
        {sectionDataResource.withRelationship(fr.relationships.noItems.name,
          (rel) => (
            <NoItemsAdded
              title={rel.meta('title')}
              subtitle={rel.meta('subtitle')}
              icon={rel.meta('icon')}
            />
          ),
          () => (<InstitutionGroups groupCollection={sectionDataResource.attr('institutionGroups')} />))}
      </FDStack>
    </FDStack>
  );
}

ViewSectionLayout.propTypes = {
};

ViewSectionLayout.defaultProps = {
};

export default ViewSectionLayout;
